import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import classNames from 'classnames';
import PropTypes from 'prop-types';
import UISection from '../section/UISection';

/** See `UISection` for prop descriptions */
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIPanelSection(_ref) {
  let {
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UISection, Object.assign({}, rest, {
    className: classNames(className, 'private-panel__section')
  }));
}
UIPanelSection.propTypes = Object.assign({}, UISection.propTypes, {
  children: PropTypes.node
});

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIPanelSection.defaultProps = Object.assign({}, UISection.defaultProps);
UIPanelSection.displayName = 'UIPanelSection';